import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hpm-admin',
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminComponent {}
